export enum PackingListUploadTypeEnum {
    FILE = 'FILE',
    MANUAL = 'MANUAL',
   
}